import { createSelector } from 'reselect';

import { SelectedProjectState, ProjectListState } from './types';
import { AppState } from '../../types';

export const selectProjectList = (state: AppState): ProjectListState => state.projects.list;

export const selectProject = (state: AppState): SelectedProjectState => state.projects.selected;

export const selectAllowChangeProjectStatus = (state: AppState): boolean => state
  .projects.changeStatus.canChangeStatus;

export const selectDuplicateProject = (state: AppState): SelectedProjectState => state.projects.duplicate;

export const isProjectPersistent = createSelector(
  selectProject,
  (state) => Boolean(state.data?.id),
);

export const selectProjectTitle = createSelector(
  selectProject,
  (state) => state.data?.title,
);

export const selectIsProjectOwner = (state: AppState): boolean => {

  const projectOwnerId = state.projects.selected.data?.user_owner_id;
  const currentUserId = state.user.current.data?.id;

  return projectOwnerId === currentUserId;
};
